import { LabelVariant } from '@workwhile/ui'

// Mirrors the backend `JetAssignmentStatus` enum (lib/enum_definitions.py).
export const JET_ASSIGNMENT_STATUS_VALUES = [
  'scheduled',
  'completed',
  'skip_approved',
  'other',
] as const

export type JetAssignmentStatus = (typeof JET_ASSIGNMENT_STATUS_VALUES)[number]

export const JET_ASSIGNMENT_STATUS_LABELS: Record<JetAssignmentStatus, string> =
  {
    scheduled: 'Scheduled',
    completed: 'Completed',
    skip_approved: 'Skip approved',
    other: 'Other',
  }

export const JET_ASSIGNMENT_STATUS_LABEL_VARIANTS: Record<
  JetAssignmentStatus,
  LabelVariant
> = {
  scheduled: 'warning',
  completed: 'success',
  skip_approved: 'error',
  other: 'neutral',
}

export const JET_ASSIGNMENT_STATUS_OPTIONS: {
  value: JetAssignmentStatus
  label: string
}[] = JET_ASSIGNMENT_STATUS_VALUES.map((value) => ({
  value,
  label: JET_ASSIGNMENT_STATUS_LABELS[value],
}))

// Ordering controls. `dateField` selects which timestamp the `days ago` window
// filters against; `sortBy` selects the ordering column (server-side).
export const JET_ASSIGNMENT_DATE_FIELD_VALUES = [
  'created_at',
  'target_starts_at',
] as const

export type JetAssignmentDateField =
  (typeof JET_ASSIGNMENT_DATE_FIELD_VALUES)[number]

export const JET_ASSIGNMENT_DATE_FIELD_LABELS: Record<
  JetAssignmentDateField,
  string
> = {
  created_at: 'Created at',
  target_starts_at: 'Target start',
}

export const JET_ASSIGNMENT_SORT_BY_VALUES = [
  'created_at',
  'target_starts_at',
  'updated_at',
  'status',
] as const

export type JetAssignmentSortBy = (typeof JET_ASSIGNMENT_SORT_BY_VALUES)[number]

export const JET_ASSIGNMENT_SORT_BY_LABELS: Record<
  JetAssignmentSortBy,
  string
> = {
  created_at: 'Created at',
  target_starts_at: 'Target start',
  updated_at: 'Updated at',
  status: 'Status',
}

export const JET_ASSIGNMENT_SORT_DIR_VALUES = ['asc', 'desc'] as const

export type JetAssignmentSortDir =
  (typeof JET_ASSIGNMENT_SORT_DIR_VALUES)[number]
